import "antd/dist/antd.less";
import React, { useEffect, useState, useRef } from "react";
import { Divider, Select, Layout, Button, Steps, Spin  } from "antd";
import "./styles.less";
import { Link } from "react-router-dom";
import { css } from "@emotion/react";
import favicon from "/favicon.png";
import PreviewContent from './components/PreviewContent'
import PreviewImage from "./components/PreviewImage";
import SoftwareMap from "@/components/SoftwareMap/SoftwareMap.jsx";
import useHTTP from "@/hooks/useHTTP.mjs";
import useDocTitle from '@/hooks/useDocTitle.mjs'
import useApi from "./useApi.mjs";
import { markLastOfType } from "./util.js";
import IconLink from '@/components/SoftwareMap/nodes/_OPR/icon-fopr-link.svg?react'
import IconMenu from '@/components/SoftwareMap/nodes/_OPR/icon-fopr-menu.svg?react'
import IconTab from '@/components/SoftwareMap/nodes/_OPR/icon-fopr-tab.svg?react'
import IconButton from '@/components/SoftwareMap/nodes/_OPR/icon-fopr-button.svg?react'
import IconCheck from '@/components/SoftwareMap/nodes/_OPR/icon-fopr-check.svg?react'
import IconInput from '@/components/SoftwareMap/nodes/_OPR/icon-fopr-input.svg?react'
import IconLetters from '@/components/SoftwareMap/nodes/icons/IconLetters.jsx'
import Color from '@/components/SoftwareMap/nodes/Color.mjs'
import IconFlag from '@/components/SoftwareMap/nodes/AR/icons/icon-flag.svg?react'
import parseMap from '@/components/SoftwareMap/scripts/parseMap.mjs';

let stepTime = 600;

const arTypeLabel = {
  "OPR_MENU": "点击菜单",
  "OPR_BUTTON": "点击按钮",
  "OPR_CLICK_URL": "点击链接",
  "OPR_CLICK_TAB":  "点击页签",
  "OPR_SHORTCUT": "快捷键",
  "OPR_CHECK_ROW": "勾选行记录",
  "OPR_INPUT": "录入数据",
  // "OPR_GENERAL": "通用界面操作"
}
const arTypeIcon = {
  "OPR_MENU": <IconMenu fill={Color.BLUE} />,
  "OPR_BUTTON": <IconButton fill={Color.BLUE} />,
  "OPR_CLICK_URL": <IconLink fill={Color.BLUE} />,
  "OPR_CLICK_TAB": <IconTab fill={Color.BLUE} />,
  "OPR_SHORTCUT": <IconLetters
                  textColor={Color.BLUE}
                  letters="K"
              />,
  "OPR_CHECK_ROW": <IconCheck fill={Color.BLUE} />,
  "OPR_INPUT": <IconInput fill={Color.BLUE} />,
  // "OPR_GENERAL": "general"
}


const cssLayoutHeader = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: 0,
});
const cssLayoutHeaderLeft = css({
  fontSize: 20,
  color: "#fff",
  padding: "0 15px",
  display: "flex",
  alignItems: "center",
  width: 'calc(50% - 160px)',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});
const cssLayoutHeaderCenter = css({
  fontSize: 14,
  fontWeight: "bold",
  color: "#fff",
  padding: "0 15px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 12,
});
const cssLayoutHeaderRight = css({
  color: "#fff",
  width: '360px',
  display: 'flex',
  justifyContent: 'end'
//   gap: 12,
});
const cssLink = css({
  fontWeight: "bold",
  color: "#fff",
  display: "flex",
  alignItems: "center",
});
const cssLogo = css({
  height: 22,
  marginRight: 8,
});
const cssDivider = css({
  borderColor: "#fff",
});



const Header = ({ uvObj,  setScaleNum, showUvName, headData }) => {
  const handleChange = (val) => {
    setScaleNum(val);
  };

  return (
    <Layout.Header css={cssLayoutHeader}>
      <div css={cssLayoutHeaderLeft}>
        <Link css={cssLink} reloadDocument to="/" title={"进入工作台"}>
          <img css={cssLogo} alt="logo" src={favicon} />
          软件逻辑地图
        </Link>
        <Divider type="vertical" css={cssDivider} />
        <span style={{ fontSize: 14, fontWeight: "bold" }}>界面看板（集成用例 - {headData.sfName} {headData.sfNo ? `-${headData.sfNo}` : ''} ）</span>
      </div>

      <div css={cssLayoutHeaderCenter}>
        <span title={uvObj.uvName} className="header_uvname_uc">
          {uvObj.uiName && `${uvObj.uiName}`} {showUvName && `（${uvObj.uvName}）`}
        </span>

        {uvObj.uvType == "MOBILE" && (
          <Select
            defaultValue={1}
            bordered={false}
            style={{ color: "#fff", width: 58 }}
            showArrow={false}
            size="small"
            onChange={handleChange}
            options={[
              {
                value: 0.35,
                label: "35%",
              },
              {
                value: 0.5,
                label: "50%",
              },
              {
                value: 0.8,
                label: "80%",
              },
              {
                value: 1,
                label: "100%",
              },
              {
                value: 1.2,
                label: "120%",
              },
              {
                value: 1.5,
                label: "150%",
              },
              {
                value: 2,
                label: "200%",
              },
            ]}
          />
        )}
      </div>
      <div css={cssLayoutHeaderRight}></div>
    </Layout.Header>
  );
};

const FormilyUcPreview = (props) => {
  const params = new URLSearchParams(location.search.split("?")[1]);
  const [uvObj, setUvObj] = useState({});
  const [current, setCurrent] = useState(null);
  const [showUvName, setShowUvName] = useState(false);
  const [currentType, setCurrentType] = useState('IMG')
  const [shcemaData, setSchemaData] = useState({});
  const api = useApi();
  const [stepData, setStepData] = useState([])
  const [stepNum, setStepNum] = useState(null);
  const [steping, setSteping] = useState(false);
  const [percent, setPercent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mapData, setMapData] = useState({
    root: {
      bizNodeType: "UC",
    }
  });

  const [headData, setHeadData] = useState({});

  const stepTimer = useRef(null);
  const intervalTimer = useRef(null);

  const [scaleNum, setScaleNum] = useState(1);
  
  const containerRef = useRef(null);
  const stepRefs = useRef([]);

  useDocTitle('集成用例界面看板');

  useEffect(() => {
    doQuery()
  }, [])
  useEffect(() => {
    if(typeof stepNum != 'number') return;
    if (stepRefs.current[stepNum]) {
      stepRefs.current[stepNum].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
    if(stepNum == 0) {
      handleEnd();
      return;
    }
    if(stepNum == (stepData.length + 1)) {
      handleEnd();
      return;
    };

    const arrData = stepData[stepNum - 1].children;
      if(!arrData.length) return handleEnd();
      const uvData = arrData.find(item => item.bizNodeType == 'UV');
      const uiData = arrData.find(item => item.bizNodeType == 'UI');

      const currentData = uvData || uiData || arrData[0];
        if(!currentData) return handleEnd();

        if (currentData.bizNodeType == 'UI') {
          fetchUIData(currentData.pkid, true)
          handleEnd();
          return;
        }

        if (currentData.bizNodeType == 'UV') {
          handleFetchData(currentData.pkid)
          handleEnd();
          return;
        }
        
        if (currentData.bizNodeType == 'UE') {
          setUvObj({
            // uvType: data.uvType,
            // uvName: data.uvName,
            fileId: undefined,
            uiId: currentData.pkid,
            uiName: currentData.ueName
          });
          handleEnd();
          return;
        }
    
  }, [stepNum])

  const doQuery = () => {
    const sfId = params.get('sfId');
    
    if(sfId) {
      handleFetchStepData(sfId)
    }
  }

  // 若是存在uvId 获取视图map信息
  const handleFetchStepData = async (sfId) => { 
    setLoading(true)
    try {
      const data = await api.fetchUcListOpr({ pkid: sfId });
      if (data) {
        const sfOprs = data.sfOprs || []
        const arr = markLastOfType(sfOprs)
        const sfMap = JSON.parse(data.sfMap)
        setMapData(sfMap)
        setHeadData({
          sfName: sfMap.root.sfName,
          sfNo: sfMap.root.sfNo,
        })
        setStepData(arr)
        setStepNum(0)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  }

  // 若是存在uvId 获取视图map信息
  const handleFetchData = async (uvId, isNext=true) => { 
    try {
      const data = await api.fetchUmUv({ pkid: uvId });
      if (data) {
        setSchemaData(data)
        const { demoType, prjId, sVer } = data;
        const fileIdData = data?.demoMap && JSON.parse(data?.demoMap)
          ? parseMap(data?.demoMap)[0]
          : undefined;
        const fileId = fileIdData?.data?.fileId;
        setUvObj({
          uvType: data.uvType,
          uvName: data.uvName,
          fileId,
          uiId: data.uiId,
          uiName: data.uiName
        });
        setCurrentType(demoType)
        setCurrent(data.uiId)

        if(isNext && data.uiId != current) fetchUIData(data.uiId);
      }
    } catch (error) {
      console.log(error);
    }
  }


  // 获取当前用户界面的子视图是否大于1，来判断是否显示视图名称
  const fetchUIData = async (id, isNext=false) => {
    if(!id) return;
    const data = await api.fetchUiById({pkid: id});
    if(data) {
      const uiMap = JSON.parse(data?.uiMap)?.root?.children || [];
      const uidemo = uiMap.find(item => item.bizNodeType == 'UI_DEMO')?.children || [];
      setShowUvName(uidemo.length > 1)
      if(!uidemo.length) {
        setUvObj({
          uvType: data.uvType,
          uvName: data.uvName,
          fileId: undefined,
          uiId: data.pkid,
          uiName: data.uiName
        });
        setCurrentType('IMG')
        setCurrent(data.pkid)
        return
      };
      const uvData = uidemo[0];

      if(isNext) {
        handleFetchData(uvData.pkid, false)
      }
    }
  };

  // 开始执行
  const handleNext = (index = stepNum) => {
    if(stepTimer.current) clearTimeout(stepTimer.current);
    if(intervalTimer.current) clearInterval(intervalTimer.current);
    if(index == (stepData.length)) {
      handleEnd()
      return;
    };
    if(!steping) {
      setSteping(true)
    }
    
    setPercent(0);
    handleProgress();
    stepTimer.current = setTimeout(() => {
      let nextStep = index + 1;
      setStepNum(nextStep);
      setPercent(0);
    }, stepTime);
  };

  // 步骤进度
  const handleProgress = () => { 
    // 模拟进度条实现，在一秒内将进度percent从0-100改变，可以只经历4个数值
    // 计算时间间隔（总时间1秒，分3个间隔）
      const percentages = [0, 25, 50, 75, 100];
      const intervalTime = stepTime / (percentages.length - 1);
      // 定义四个阶段的进度值
      let currentIndex = 0;

      intervalTimer.current = setInterval(() => {
        currentIndex++;
        if (currentIndex < percentages.length) {
          const percent = percentages[currentIndex];
          setPercent(percent);
        } else {
          clearInterval(intervalTimer.current); // 进度完成后清除定时器
        }
      }, intervalTime);
    

  };

  // 执行结束 
  const handleEnd = () => {
    if(stepTimer.current) clearTimeout(stepTimer.current);
    if(steping) {
      setSteping(false)
    }
  };

  // 初始化
  const handleRestart = () => {
    setStepNum(0);
  };

  return (
    <div className="formilyFrame">
      <Header setScaleNum={setScaleNum} showUvName={showUvName} uvObj={uvObj} headData={headData} />
      <div className="formilyUc-content">
        <div className="left-content-box">
          {
            stepNum === 0  &&
            <SoftwareMap mapData={mapData} />
          }
          {
            stepNum > 0 && <>
              {currentType == "IMG" ? (
                <PreviewImage current={current} uvObj={uvObj} noBtns />
              ) : (
                <PreviewContent
                  current={current}
                  shcemaData={shcemaData}
                  uvType={currentType}
                  scaleNum={scaleNum}
                />
              )}
            </>
          }
        </div>
        <div className="right-content-box" >
          <div ref={containerRef} className="timeline-box" style={{ paddingTop: stepData[0]?.isFirstScene && '30px' }}>
            <Spin spinning={loading} >
              {stepData && stepData.length > 0 ? <Steps
                current={stepNum}
                percent={percent}
                direction="vertical"
                onChange={(current) => handleNext(current - 1)}
                items={stepData.map((item, index) => ({
                  title: (
                    <div
                      ref={el => stepRefs.current[index] = el}
                      style={{
                        fontSize: "16px",
                        display: 'inline-block',
                        marginBottom: item.isLastScene ? '44px' : '12px',
                        color:
                          (stepData[index]?.bizNodeType == "UI" ||
                            stepData[index]?.bizNodeType == "UV") &&
                          "#0099CC",
                        fontWeight: (stepData[index]?.bizNodeType == "UI" ||
                            stepData[index]?.bizNodeType == "UV") && "bold"
                      }}
                    >
                      {!!item.oprScene && item.isFirstScene && <div title={item.oprScene} className="abslute-group" ><IconFlag />{item.oprScene}</div>}
                      <span className="icon-box">{arTypeIcon[item.oprType] || ''}</span>
                      <span style={{color: "#0099CC"}} > {`${arTypeLabel[item.oprType] || ''} ${arTypeLabel[item.oprType] && item.oprTitle ? "：" : ""} `}</span>
                      <span style={{color: "#000" }} >{`${item.oprTitle || ''}`}</span>
                    </div>
                  ),
                }))}
              /> : <div style={{ width: '100%', minHeight: '200px' }} ></div>}
            </Spin>
          </div>
          <div style={{ width: "100%" }}>
            <Button
              disabled={stepNum > stepData.length - 1}
              loading={steping && stepNum <= stepData.length - 1}
              type="primary"
              onClick={() => handleNext()}
            >
              执行
            </Button>
            {stepNum >= stepData.length && !steping && (
              <Button style={{ marginLeft: "12px" }} onClick={handleRestart}>
                初始化
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormilyUcPreview;
